import config from '../config'

export function getApiUrl(path) {
  return config.urls.apiUrl + path
}

export function getApiUrlObject(path) {
  if (config.env.production) {
    return new window.URL(getApiUrl(path))
  } else {
    return new window.URL(getApiUrl(path), window.location.href)
  }
}
